export default {
  mergedInvoices: []
}
